(function($){
  'use strict';

  if(!$.gnv){
      $.gnv = new Object();
  };

  $.gnv.hotelRooms = function (){
    var 
      $openAccordion = $('.b-rooms__open-accordion'),
      $slick_slider = $('.b-rooms__container.b-rooms__container--slick '),
      settings = {
        dots: true,
        infinite: false,
        speed: 300,
        nextArrow: false,
        prevArrow: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: false,
        draggable: false,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
              infinite: false,
              draggable: true
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              infinite: false,
              draggable: true,
            }
          }
        ]
      },

    initSlider = function(){
      $slick_slider.addClass('gnv-slick');
      $slick_slider.slick(settings);
    },

    resize = function(width){
      checkSize();
    },

    checkSize = function(){
      if ($(window).width() > 1024) {
        if ($slick_slider.hasClass('slick-initialized')) {
          $slick_slider.slick('unslick');
          $slick_slider.removeClass('gnv-slick');
        }
        return
      }

      if (!$slick_slider.hasClass('slick-initialized')) {
        initSlider();
      }
    };
    
    initSlider();
    checkSize();

    $openAccordion.click(function(e){
      $(this).find('.text-close, .text-open').toggle();
      $(this).toggleClass('accordion-opened');
      if( $(this).hasClass('accordion-opened') ){
        $('html, body').animate({
          scrollTop: $(this).offset().top
        }, 500);
      } 
    });

    window.resizedCallback.push(resize);

  };

})(jQuery);
